import script from "./timeline-titulo-data.vue?vue&type=script&setup=true&lang=js"
export * from "./timeline-titulo-data.vue?vue&type=script&setup=true&lang=js"

import "./timeline-titulo-data.vue?vue&type=style&index=0&id=0ccb4602&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ccb4602"]])

export default __exports__